import type { BrokerListQuery } from '@/schemas/broker'

/**
 * Every broker that traded, for Compare's picker and its quick-add chips —
 * and, now, for `CompareScreen.loader.ts` to prefetch at hover-intent.
 *
 * One page of 100 covers the ~52 houses NEPSE lists, sorted by turnover —
 * which is also the order the empty state's "top 4 by turnover" chips want, so
 * one query serves both. `period` is `'today'`, the same literal the rest of
 * Compare uses: it draws no period control.
 *
 * Moved out of `CompareView.tsx` (a component file) into its own `lib`
 * module: route loaders are not code-split, so anything they import ships in
 * the entry chunk, and a loader may not import a component module at all —
 * see docs/route-loading.md, "Steps" step 2.
 */
export const COMPARE_BROKER_LIST_QUERY: BrokerListQuery = {
  page: 1,
  pageSize: 100,
  period: 'today',
  sort: 'turnover',
}
